"use client";

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["error", "helper", "id", "name", "label", "maxLength", "resizable"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Core } from "@faire/design-tokens";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { useUniqueId } from "@faire/web--source/ui/hooks/useUniqueId";
import * as React from "react";
import styled, { useTheme } from "styled-components";
import { Spacer } from "../../spacing";
import { Typography } from "../../Typography";
import { getDerivedPropsFromErrorProps } from "../error";
import { FormInputLabel, inputStyles } from "../index";
var InnerTextArea = styled.textarea.withConfig({
  displayName: "TextArea__InnerTextArea"
})(["", ";appearance:none;resize:", ";padding:8px 16px;color:", ";"], inputStyles, function (props) {
  return props.$resizable ? "vertical" : "none";
}, function (props) {
  return props.disabled ? Core.text.disabled : Core.text.default;
});
var CharacterCount = styled(Typography).attrs({
  variant: "labelSansRegular"
}).withConfig({
  displayName: "TextArea__CharacterCount"
})(["&&&{color:", ";text-align:end;position:relative;right:4px;}"], function (props) {
  var _props$theme$input$he, _props$theme, _props$theme$input$he2;
  return (_props$theme$input$he = (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$input$he2 = _props$theme.input.helper) === null || _props$theme$input$he2 === void 0 ? void 0 : _props$theme$input$he2.color) !== null && _props$theme$input$he !== void 0 ? _props$theme$input$he : Core.text.subdued;
});
var ErrorText = styled(Typography).attrs({
  variant: "labelSansRegular",
  color: Core.text.critical
}).withConfig({
  displayName: "TextArea__ErrorText"
})(["flex:1;"]);
var HelperText = styled(Typography).attrs({
  variant: "labelSansRegular"
}).withConfig({
  displayName: "TextArea__HelperText"
})(["&&&{color:", ";flex:1;}"], function (props) {
  var _props$theme$input$he3, _props$theme2, _props$theme2$input$h;
  return (_props$theme$input$he3 = (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$input$h = _props$theme2.input.helper) === null || _props$theme2$input$h === void 0 ? void 0 : _props$theme2$input$h.color) !== null && _props$theme$input$he3 !== void 0 ? _props$theme$input$he3 : Core.text.subdued;
});
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/slate/component/input/web/text-area-input)
 */
export var TextArea = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$value, _theme$input$label, _theme$input$label$co, _theme$input$label2;
  var value = (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : "";
  var error = props.error,
    helper = props.helper,
    id = props.id,
    name = props.name,
    label = props.label,
    maxLength = props.maxLength,
    resizable = props.resizable,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var uniqueId = useUniqueId("text-area-input-");
  var _getDerivedPropsFromE = getDerivedPropsFromErrorProps({
      error: error
    }),
    showErrorState = _getDerivedPropsFromE.showErrorState,
    showErrorMessage = _getDerivedPropsFromE.showErrorMessage,
    errorMessage = _getDerivedPropsFromE.errorMessage;
  var message = null;
  if (showErrorMessage) {
    message = /*#__PURE__*/React.createElement(ErrorText, null, errorMessage);
  } else if (helper) {
    message = /*#__PURE__*/React.createElement(HelperText, null, helper);
  }
  return /*#__PURE__*/React.createElement(Column, {
    style: {
      flex: 1,
      height: "inherit"
    }
  }, /*#__PURE__*/React.createElement(Column, {
    style: {
      height: "inherit"
    }
  }, label ? (/*#__PURE__*/React.createElement(FormInputLabel, {
    "$typography": _objectSpread(_objectSpread({}, (_theme$input$label = theme.input.label) !== null && _theme$input$label !== void 0 ? _theme$input$label : {}), {}, {
      color: showErrorState ? Core.text.critical : (_theme$input$label$co = (_theme$input$label2 = theme.input.label) === null || _theme$input$label2 === void 0 ? void 0 : _theme$input$label2.color) !== null && _theme$input$label$co !== void 0 ? _theme$input$label$co : Core.text.default
    }),
    htmlFor: id !== null && id !== void 0 ? id : uniqueId,
    style: {
      height: "inherit"
    }
  }, label)) : null, /*#__PURE__*/React.createElement(InnerTextArea, _objectSpread({
    "$resizable": resizable,
    "$showErrorState": showErrorState,
    id: id !== null && id !== void 0 ? id : uniqueId,
    name: name,
    maxLength: maxLength,
    ref: ref
  }, rest))), maxLength || errorMessage || helper ? /*#__PURE__*/React.createElement(Spacer, {
    size: 4
  }) : null, /*#__PURE__*/React.createElement(Row, {
    justify: "space-between",
    style: {
      flexDirection: "row-reverse"
    }
  }, isNotUndefined(maxLength) ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CharacterCount, {
    theme: theme
  }, value.length, "/", maxLength), /*#__PURE__*/React.createElement(Spacer, {
    size: 10
  }))) : null, message));
});